import { createActionsColumn, WbTable } from '@agilelab/plugin-wb-platform';
import { parseEntityRef, stringifyEntityRef } from '@backstage/catalog-model';
import { useRouteRef } from '@backstage/core-plugin-api';
import { catalogLocationCreatePermission } from '@backstage/plugin-catalog-common/alpha';
import { usePermission } from '@backstage/plugin-permission-react';
import { FC } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { selectedTemplateRouteRef } from '../../routes';
import { useTechDocsDrawer } from '../hooks/useTechDocsDrawer';
import { useScaffolderPageContext } from './context/useScaffolderPageContext';
import { useWitboostCustomTemplates } from './utils';
import {
  ActionColumn,
  DescriptionColumn,
  ErrorColumn,
  NameColumn,
  TagsColumn,
  TypeColumn,
} from './columns';

export const ScaffolderTable: FC = () => {
  const navigate = useNavigate();
  const { entities, loading } = useScaffolderPageContext();
  const witboostCustomTemplates = useWitboostCustomTemplates(entities);
  const { openDocs, TechDocsDrawer } = useTechDocsDrawer();
  const location = useLocation();
  const knownSystem = location.state?.system;
  const knownDomain = location.state?.domain;

  const { allowed } = usePermission({
    permission: catalogLocationCreatePermission,
  });

  const templateRoute = useRouteRef(selectedTemplateRouteRef);

  return (
    <>
      <WbTable<any>
        components={{
          tableLoader: { loading },
          tableContent: {
            columns: [
              {
                field: 'metadata.title',
                headerName: 'Name',
                width: 300,
                fieldRender: NameColumn,
                sortable: true,
              },
              {
                field: 'metadata.classDetails.displayName',
                headerName: 'Type',
                fieldRender: TypeColumn,
                sortable: true,
                width: 150,
              },
              {
                field: 'metadata.description',
                headerName: 'Description',
                fieldRender: DescriptionColumn,
                sortable: true,
              },
              {
                field: 'metadata.tags',
                headerName: 'Tags',
                fieldRender: TagsColumn,
              },
              createActionsColumn({
                width: 100,
                renderActions: e => (
                  <div
                    style={{
                      display: 'flex',
                      gap: '8px',
                      alignItems: 'center',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <ErrorColumn
                      entity={e}
                      witboostCustomTemplates={witboostCustomTemplates}
                    />
                    <ActionColumn
                      entity={e}
                      witboostCustomTemplates={witboostCustomTemplates}
                      onOpenDocs={openDocs}
                    />
                  </div>
                ),
              }),
            ],
            rows: entities,
            onRowClick: (entity, e) => {
              e.stopPropagation();
              e.preventDefault();
              const { name, namespace } = parseEntityRef(
                stringifyEntityRef(entity),
              );
              const href = templateRoute({ templateName: name, namespace });

              if (allowed) {
                const to =
                  knownDomain && knownSystem
                    ? `${href}?formData=%7B"domain"%3A"${knownDomain}"%2C"dataproduct"%3A"system:${knownSystem}"%7D`
                    : href;

                navigate(to);
              }
            },
          },
        }}
      />
      {TechDocsDrawer}
    </>
  );
};
